import Grid2 from '@mui/material/Unstable_Grid2';
import { TitleWithSeparator } from 'src/shared/components/TitleWithSeparator';
import { type SvgIconComponent } from '@mui/icons-material';
import { type ReactElement } from 'react';
import { Box, Typography } from '@mui/material';
import { IconBoxWrapper } from './style';
import { ShowLoading } from 'src/shared/components/ShowLoading';
import DOMPurify from 'dompurify';
type StepProps = {
  title: string;
  subtitle: string;
  Icon: SvgIconComponent;
  children?: ReactElement;
  isLoading?: boolean;
};

export const Step = ({ title, subtitle, Icon, children, isLoading }: StepProps) => {
  if (isLoading) {
    return <ShowLoading />;
  }

  return (
    <Grid2 mb={4}>
      <Grid2 xs={12} mb={1}>
        <TitleWithSeparator>{title}</TitleWithSeparator>
      </Grid2>
      <Grid2>
        <Grid2>
          <Box display="flex" alignItems="center" columnGap={2} mb={2} mt={2}>
            <IconBoxWrapper>
              <Icon color="primary" />
            </IconBoxWrapper>

            <Box>
              <Typography
                variant="body1"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(subtitle)
                }}
              />
            </Box>
          </Box>
        </Grid2>
        <Grid2 ml={8}>{children && children}</Grid2>
      </Grid2>
    </Grid2>
  );
};
